import { StationeryTemplate } from './DesignsGallery.types';
import { useApplySearchFiltersToTemplates } from './useApplySearchFiltersToTemplates';
import { useActivePrintFiltersVar } from './utils/activePrintFiltersCache';
import { useCallback } from 'react';

/**
 * Will need to revisit this once we move filtering capabilities to the BE.
 */
export const useApplyFiltersToTemplates = () => {
  const activePrintFilters = useActivePrintFiltersVar();
  const { applySearchFiltersToTemplates, useSearchResults, searchError } = useApplySearchFiltersToTemplates();
  const searchResults = useSearchResults();

  const applyFiltersToTemplates = useCallback(
    (templates: StationeryTemplate[]) => {
      if (searchResults.searchCompleted) {
        templates = applySearchFiltersToTemplates(templates);
      }

      if (Object.keys(activePrintFilters).length === 0) {
        return templates;
      }

      const filtered = templates.filter(template => {
        return template.mappedTags.some(tagCompositeCode => activePrintFilters[tagCompositeCode]);
      });

      if (filtered.length === 0 && searchResults.searchCompleted) {
        searchError();
        return templates;
      }

      return filtered;
    },
    [activePrintFilters, applySearchFiltersToTemplates, searchError, searchResults.searchCompleted]
  );

  return { applyFiltersToTemplates };
};
